import { render, staticRenderFns } from "./MobileMenuTakeover.vue?vue&type=template&id=30871329"
import script from "./MobileMenuTakeover.vue?vue&type=script&lang=js"
export * from "./MobileMenuTakeover.vue?vue&type=script&lang=js"
import style0 from "./MobileMenuTakeover.vue?vue&type=style&index=0&id=30871329&prod&lang=scss&module=%24s"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports